<template>
  <page-tabs
      ref="pageTabs"
      :tabs="[
        {icon:'mdi-phone-log', name:'Журнал звонков', path:'/contactCenter/callGroup/'},
        {icon:'mdi-phone-missed', name:'Задачи по звонкам', path:'/contactCenter/callTask/'},
        {icon:'mdi-message-text-outline', name:'Чаты', path:'/contactCenter/chat/'},
        {icon:'mdi-message-text-fast-outline', name:'Рассылка', path:'/contactCenter/distribute/'},
    ]"
  >
    <template v-slot:default="{index:index}">
      <call-groups v-if="index===0 && mountedDelay"
                   ref="callGroups"
                   :filter.sync="filter"
                   :callTargets="callTargets"
                   :callResults="callResults"
                   :callDirections="callDirections"
                   :statuses="statuses"
      />
      <call-tasks v-if="index===1 && mountedDelay"
                  :filter.sync="filter"
                  :callTargets="callTargets"
                  :callResults="callResults"
                  :callDirections="callDirections"
                  :statuses="statuses"
      />
      <chat-clients v-if="index===2 && mountedDelay" />
      <distribute v-if="index===3 && mountedDelay" />
    </template>
  </page-tabs>
</template>

<script>
import moment from "moment";
import {Entity_CallResult, Entity_CallTarget} from "../../../EntityStoreCacheService";
import CallGroups from "@/views/ContactCenter/Call/CallGroups.vue";
import CallTasks from "@/views/ContactCenter/Call/CallTasks.vue";
import PageTabs from "@/componentsV2/base/PageTabs.vue";
import ChatClients from "@/views/ContactCenter/Messenger/ChatClients.vue";
import Distribute from "@/views/ContactCenter/Messenger/Distribute.vue";
import mounted from "@/mixins/mounted";

export default {
  components: {Distribute, PageTabs, CallTasks, CallGroups, ChatClients},
  mixins:[mounted],
  data:()=>({
    filter: {
      dateFrom:moment().format('DD.MM.YYYY'),
      dateTo:moment().format('DD.MM.YYYY'),
      callDirections: [],
      statuses: [],
      phone: null,
      callTarget: null,
      callResult: null,
      userClientState: [],
      users: [],
      admins: []
    },
    callTargets:[],
    callResults:[],
    callDirections:[
      {name:'Внутренний',id:0,icon:'mdi-phone-incoming-outgoing'},
      {name:'Входящий',id:1, icon: 'mdi-phone-incoming'},
      {name:'Исходящий',id:2, icon: 'mdi-phone-outgoing'},
    ],
    statuses: [
      {name:'В процессе',id:'progress', color:'#428eda'},
      {name:'Успешно',id:'success', color:'#02924d'},
      {name:'Не отвечено',id:'fail', color:'#F44336'},
      {name:'Не отвечено в нерабочее время',id:'failNonWork', color:'#607D8B'},
    ],
  }),
  watch:{
    $route(){
      this.$refs.pageTabs.indexLoad();
      this.$nextTick(()=>{
        if(typeof this.$refs.callGroups!=='undefined')
          this.$refs.callGroups.externalTrigger();
      })
    }
  },
  mounted() {
    if(typeof this.$refs.callGroups!=='undefined')
      this.$refs.callGroups.externalTrigger();

    new Entity_CallTarget()
        .selects(Entity_CallTarget.id)
        .selects(Entity_CallTarget.name)
        .selects(Entity_CallTarget.comment)
        .selects([Entity_CallTarget.callResults, Entity_CallResult.id].join('.'))
        .selects([Entity_CallTarget.callResults, Entity_CallResult.name].join('.'))
        .selects([Entity_CallTarget.callResults, Entity_CallResult.type].join('.'))
        .selects([Entity_CallTarget.callResults, Entity_CallResult.comment].join('.'))
        .order(Entity_CallTarget.sort, true)
        .page(1)
        .onPage(1000)
        .addStateCallback((v)=>{
          if(v.success) this.callTargets = v.items;
        })
        .request()
    new Entity_CallResult()
        .selects(Entity_CallResult.id)
        .selects(Entity_CallResult.name)
        .selects(Entity_CallResult.type)
        .selects(Entity_CallResult.comment)
        .selects([Entity_CallResult.callTargets, Entity_CallTarget.id].join('.'))
        .order(Entity_CallResult.type, true)
        .order(Entity_CallResult.sort, true)
        .page(1)
        .onPage(1000)
        .addStateCallback((v)=>{
          if(v.success) this.callResults = v.items;
        })
        .request()
  },
}
</script>